// extracted by mini-css-extract-plugin
export var productImage = "_jc-1";
export var viewLink = "_jc-2";
export var wishlistItem = "_jc-0";